import { FeatureFlagKey } from "encamp-shared/src/featureFlags";

type Flags = Partial<Record<FeatureFlagKey, boolean>>;

/** Manifest-side episodic events: the waste module plus the episodic-events flag. */
export function episodicDeclarationsEnabled(flags: Flags): boolean {
  return (
    flags[FeatureFlagKey.WasteModule] === true && flags[FeatureFlagKey.EpisodicEvents] === true
  );
}

/** The episodic events page and tile: container tracking, or the manifest-side flags. */
export function episodicEventsEnabled(flags: Flags): boolean {
  return flags[FeatureFlagKey.ContainerTracking] === true || episodicDeclarationsEnabled(flags);
}
